import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from 'sd-ui/dist/commonjs/components/Button/Button';
import Icon from '../icon';
import { trackAdobeFeature } from '../../utils/trackers/adobe';

export default class Zoom extends Component {
  constructor() {
    super();
    this.handleZoomIn = this.handleZoomIn.bind(this);
    this.handleZoomOut = this.handleZoomOut.bind(this);
  }

  handleZoomIn() {
    trackAdobeFeature('document-zoom-in');
    const { zoomIn } = this.props;
    zoomIn();
  }

  handleZoomOut() {
    trackAdobeFeature('document-zoom-out');
    const { zoomOut } = this.props;
    zoomOut();
  }

  render() {
    return (
      <div className="zoom viewer-controls u-hide-from-print">
        <Button
          id="zoom-in-button"
          tabIndex="0"
          title="Zoom in"
          onClick={this.handleZoomIn}
        >
          <Icon.Plus />
        </Button>
        <Button
          id="zoom-out-button"
          tabIndex="0"
          title="Zoom out"
          onClick={this.handleZoomOut}
        >
          <Icon.Minus />
        </Button>
      </div>
    );
  }
}

Zoom.propTypes = {
  zoomIn: PropTypes.func.isRequired,
  zoomOut: PropTypes.func.isRequired,
};
